import React from 'react';
import Search from '../../features/property-list/Search';

const SearchMap = () => {
    return (
        <Search/>
    )
    }
export default SearchMap;
